import {
  DetailedIconAddUser,
  DetailedIconBlueprint,
  DetailedIconCalendar,
  DetailedIconCamera,
  DetailedIconChecklist,
  DetailedIconCompare,
  DetailedIconDollarHome,
  DetailedIconFile,
  DetailedIconForSaleSign,
  DetailedIconHandshake,
  DetailedIconHomeTour,
  DetailedIconKeyHome,
  DetailedIconLaundry,
  DetailedIconNewConstruction,
  DetailedIconPencilDollar,
  DetailedIconPet,
  DetailedIconPhone,
  DetailedIconPiggybank,
  DetailedIconStarRising,
  DetailedIconVirtualTour,
  IconArchiveOutline,
  IconBankOutline,
  IconBuildingOutline,
  IconBulbOutline,
  IconDollarSignCircleOutline,
  IconEditFormOutline,
  IconFileOutline,
  IconHammerOutline,
  IconHOAOutline,
  IconLaundryOutline,
  IconMonitorOutline,
  IconParkingOutline,
  IconPetsOutline,
  IconProfileOutline,
  IconTaxOutline,
  IconTeamOutline,
} from '@zillow/constellation';

import DetailedIconHome from '../images/HomeSparkle.svg';

const getIconByName = ({ name, useFallbackIcon }: { name: string; useFallbackIcon?: boolean }) => {
  let Icon = null;

  switch (name) {
    case 'DetailedIconAddUser':
      Icon = DetailedIconAddUser;
      break;
    case 'DetailedIconBlueprint':
      Icon = DetailedIconBlueprint;
      break;
    case 'DetailedIconCalendar':
      Icon = DetailedIconCalendar;
      break;
    case 'DetailedIconCamera':
      Icon = DetailedIconCamera;
      break;
    case 'DetailedIconChecklist':
      Icon = DetailedIconChecklist;
      break;
    case 'DetailedIconCompare':
      Icon = DetailedIconCompare;
      break;
    case 'DetailedIconDollarHome':
      Icon = DetailedIconDollarHome;
      break;
    case 'DetailedIconFile':
      Icon = DetailedIconFile;
      break;
    case 'DetailedIconForSaleSign':
      Icon = DetailedIconForSaleSign;
      break;
    case 'DetailedIconHandshake':
      Icon = DetailedIconHandshake;
      break;
    case 'DetailedIconHome':
      Icon = DetailedIconHome;
      break;
    case 'DetailedIconHomeTour':
      Icon = DetailedIconHomeTour;
      break;
    case 'DetailedIconKeyHome':
      Icon = DetailedIconKeyHome;
      break;
    case 'DetailedIconLaundry':
      Icon = DetailedIconLaundry;
      break;
    case 'DetailedIconPiggybank':
      Icon = DetailedIconPiggybank;
      break;
    case 'DetailedIconStarRising':
      Icon = DetailedIconStarRising;
      break;
    case 'DetailedIconNewConstruction':
      Icon = DetailedIconNewConstruction;
      break;
    case 'DetailedIconPencilDollar':
      Icon = DetailedIconPencilDollar;
      break;
    case 'DetailedIconPet':
      Icon = DetailedIconPet;
      break;
    case 'DetailedIconPhone':
      Icon = DetailedIconPhone;
      break;
    case 'DetailedIconVirtualTour':
      Icon = DetailedIconVirtualTour;
      break;
    case 'IconLaundryOutline':
      Icon = IconLaundryOutline;
      break;
    case 'IconTeamOutline':
      Icon = IconTeamOutline;
      break;
    case 'IconFileOutline':
      Icon = IconFileOutline;
      break;
    case 'IconEditFormOutline':
      Icon = IconEditFormOutline;
      break;
    case 'IconDollarSignCircleOutline':
      Icon = IconDollarSignCircleOutline;
      break;
    case 'IconParkingOutline':
      Icon = IconParkingOutline;
      break;
    case 'IconTaxOutline':
      Icon = IconTaxOutline;
      break;
    case 'IconPetsOutline':
      Icon = IconPetsOutline;
      break;
    case 'IconBankOutline':
      Icon = IconBankOutline;
      break;
    case 'IconHOAOutline':
      Icon = IconHOAOutline;
      break;
    case 'IconArchiveOutline':
      Icon = IconArchiveOutline;
      break;
    case 'IconMonitorOutline':
      Icon = IconMonitorOutline;
      break;
    case 'IconBulbOutline':
      Icon = IconBulbOutline;
      break;
    case 'IconHammerOutline':
      Icon = IconHammerOutline;
      break;
    case 'IconProfileOutline':
      Icon = IconProfileOutline;
      break;
    default:
      return useFallbackIcon ? IconBuildingOutline : null;
  }

  return Icon;
};

export { getIconByName };
